import * as React from 'react';
import classnames from 'classnames';

import { FormField } from 'components/form';
import InfoNote from 'components/info-note/InfoNote';
import InputRadio from 'components/inputs/input-radio/InputRadio';

import { __t, applyTranslations } from 'utils/language';

import type { TextEntry } from 'types';

import './offer-shipping-form.scss';

import type { SyntheticEvent } from 'react';

applyTranslations(require('./offer-shipping-form.i18n.json'));

type Props = {
  isBulkOfferActive?: boolean,
  hideInfoNote?: boolean,
  includesShipping: boolean,
  onEdit: (a: any) => void
};

type ShippingRadio = 'yes' | 'no';

const INCLUDES_SHIPPING_OPTION_YES = 'yes';
const INCLUDES_SHIPPING_OPTION_NO = 'no';
const INCLUDES_SHIPPING_OPTIONS = [INCLUDES_SHIPPING_OPTION_YES, INCLUDES_SHIPPING_OPTION_NO];

function getDefaultValue(includesShipping: boolean): ShippingRadio {
  return includesShipping
    ? INCLUDES_SHIPPING_OPTION_YES
    : INCLUDES_SHIPPING_OPTION_NO;
}

class OfferShippingForm extends React.Component<Props> {
  handleHasDeliveryChanged = (event: SyntheticEvent<TextEntry>): void => {
    const { onEdit } = this.props;
    const value = event.currentTarget.value || INCLUDES_SHIPPING_OPTION_NO;

    onEdit({
      includesShipping: value === INCLUDES_SHIPPING_OPTION_YES
    });
  };

  render() {
    const { hideInfoNote, isBulkOfferActive, includesShipping } = this.props;
    const value = getDefaultValue(includesShipping);

    const sectionClasses = classnames('offer-shipping-form__section', {
      'offer-shipping-form__section--with-info-note': !hideInfoNote
    });

    return (
      <section className="offer-shipping-form" data-qa="offer-shipping-form">
        {
          !hideInfoNote && (
            <InfoNote>{__t('offer_shipping_form.includes_shipping_update_info')}</InfoNote>
          )
        }
        <div className={sectionClasses}>
          <FormField
            label={isBulkOfferActive ?
              __t('offer_shipping_form.includes_shipping_bulk_label') :
              __t('offer_shipping_form.includes_shipping_label')}
            labelType="highlighted"
            showRequiredMark
            direction="column"
            fontSize="small"
          >
            {
              INCLUDES_SHIPPING_OPTIONS.map((option) => (
                <InputRadio
                  key={`includes-shipping-option--${option}`}
                  name="includes-shipping"
                  value={option}
                  id={`includes-shipping-option--${option}`}
                  checked={value === option}
                  label={__t(`offer_shipping_form.includes_shipping_option_${option}`)}
                  onChange={this.handleHasDeliveryChanged}
                />
              ))
            }
          </FormField>
        </div>
      </section>
    );
  }
}

export default OfferShippingForm;
